<template>
  <a-card style="width:100%; height: 432px" class="bg-white" :loading="loading">
    <tk-flex middle between style="height: 60px">
      <div class="font-14">有虫粮仓/无虫粮仓数量变动</div>
      <tk-flex>
        <LevleSelect style="width: 120px" v-model="level" class="m-r-10" />
        <a-month-picker
          v-model="date"
          :allowClear="false"
          style="width: 120px"
        />
      </tk-flex>
    </tk-flex>
    <div class="chat-wrap">
      <ve-chart :options="options" />
    </div>
  </a-card>
</template>

<script>
import LevleSelect from '../../levleSelect'
import { mapGetters } from 'vuex'
import moment from 'moment'

// 获取之前15天的日期格式
export default {
  components: {
    LevleSelect
  },
  data () {
    return {
      loading: true,
      level: undefined,
      date: moment(),
      options: {
        title: {
          show: false
        },
        tooltip: {},
        dataset: {
          source: [[], [], []]
        },
        xAxis: [{ type: 'category', gridIndex: 0 }],
        yAxis: [{ gridIndex: 0 }],
        grid: [{ bottom: '10%', left: 30, right: 10, top: 10 }],
        series: [
          {
            type: 'line',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#2FBF79' }
          }
        ]
      }
    }
  },
  watch: {
    level () {
      this.getData()
    },
    date () {
      this.getData()
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    nowYear () {
      return this.date.year()
    },
    hierarchyFilter () {
      if (this.level) {
        return {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.level }
            },
            className: 'hierarchy'
          }
        }
      } else {
        return {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.userLevelTag }
            },
            className: 'hierarchy'
          }
        }
      }
    },
    dateList () {
      const startTime = moment(this.date).startOf('month')
      const endTime = moment(this.date).endOf('month')
      const days = endTime.diff(startTime, 'day') + 1
      const arr = []
      for (let index = 0; index < days; index++) {
        const currentTime = moment(startTime).add(index, 'days')
        arr.push(currentTime)
      }
      return arr
    },
    datesArr () {
      return this.dateList.map(
        element => `${element.month() + 1}.${element.date()}`
      )
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const arr1 = this.dateList.map(element => {
        return this.getNumBugByDate(element)
      })
      const arr2 = this.dateList.map(element => {
        return this.getNumNoBugByDate(element)
      })
      this.loading = true
      const res = await Promise.all([...arr1, ...arr2])
      this.loading = false
      this.undateOptions(res)
    },
    undateOptions (nums) {
      // nums = nums.map(element => element + 1)
      const year = this.nowYear
      const bugNum = nums.splice(0, nums.length / 2)
      const noBugs = nums
      this.options = {
        title: {
          show: false
        },
        legend: {
          itemHeight: 7,
          icon: 'circle',
          bottom: 0
        },
        tooltip: {
          formatter (params) {
            const [month, day] = params.name.split('.')
            const line1 = `<div style="font-size: 12px; color: #666A70;">${year}年${month}月${day}日</div>`
            const line2 = `<div style="font-size: 12px; color: #363B45;">${params.marker} ${params.seriesName}：${params.value[params.componentIndex + 1]}</div>`
            return line1 + line2
          }
        },
        dataset: {
          source: [
            ['日期', ...this.datesArr],
            ['有虫', ...bugNum],
            ['无虫', ...noBugs]
          ]
        },
        xAxis: [{ type: 'category', gridIndex: 0 }],
        yAxis: [{ gridIndex: 0 }],
        grid: [{ bottom: '15%', left: 45, right: 10, top: 10 }],
        series: [
          {
            type: 'bar',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#FEB858' }
          },
          {
            type: 'bar',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#2FC25B' }
          }
        ]
      }
    },
    async getNumNoBugByDate (date) {
      const res = await this.$tkParse.get('/classes/dayStoreResult', {
        params: {
          where: {
            hierarchy: this.hierarchyFilter,
            date: {
              $gt: moment(date)
                .startOf('day')
                .toISOString(),
              $lte: moment(date)
                .endOf('day')
                .toISOString()
            },
            bugNum: 0
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      return res.data.results.length
    },
    async getNumBugByDate (date) {
      const res = await this.$tkParse.get('/classes/dayStoreResult', {
        params: {
          where: {
            hierarchy: this.hierarchyFilter,
            date: {
              $gt: moment(date)
                .startOf('day')
                .toISOString(),
              $lte: moment(date)
                .endOf('day')
                .toISOString()
            },
            bugNum: {
              $gt: 0
            }
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      return res.data.results.length
    }
  }
}
</script>
<style lang="scss">
.chat-wrap {
  width: 100%;
  height: 324px;
  background-color: #fff;
  box-sizing: border-box;
}
.chat-wrap .echarts {
  width: 100%;
  height: 100%;
}
</style>
